/**
 * 注意書き・補足説明用のコールアウトボックス。
 *
 * - type="info"（青）/ "warning"（黄）/ "danger"（赤）/ "tip"（緑）を切り替え
 */
import type { ReactNode } from "react";

interface Props {
  type?: "info" | "warning" | "danger" | "tip";
  title?: string;
  children: ReactNode;
}

const STYLE: Record<NonNullable<Props["type"]>, { bg: string; border: string; color: string; icon: string }> = {
  info: { bg: "#EAF3FB", border: "#A5C7E2", color: "#1C4F7A", icon: "ℹ" },
  warning: { bg: "#FBF4DC", border: "#E0CB6D", color: "#7A5B0F", icon: "⚠" },
  danger: { bg: "#FBEAEA", border: "#E2A5A5", color: "#7A1C1C", icon: "⛔" },
  tip: { bg: "#E8F5EE", border: "#9FCDB2", color: "#1F5A35", icon: "💡" },
};

export function Callout({ type = "info", title, children }: Props) {
  const s = STYLE[type];
  return (
    <div
      style={{
        background: s.bg,
        border: `1px solid ${s.border}`,
        borderLeft: `4px solid ${s.border}`,
        borderRadius: 8,
        padding: "12px 16px",
        margin: "16px 0",
        color: s.color,
        fontSize: 14,
        lineHeight: 1.8,
      }}
    >
      {title && (
        <div style={{ fontWeight: 600, marginBottom: 4 }}>
          <span style={{ marginRight: 6 }}>{s.icon}</span>
          {title}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
}
